import 'css-chunksrc/client/pages/projectPage/parent/styles.scss';export default {
  "parent": "_parent_1n4bk_1",
  "icon": "_icon_1n4bk_8",
  "projectModelsIcon": "_projectModelsIcon_1n4bk_17"
};